/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatPdfIcon16Light } from './FileFormatPdfIcon16Light';
import { FileFormatPdfIcon16Regular } from './FileFormatPdfIcon16Regular';
import { FileFormatPdfIcon16Solid } from './FileFormatPdfIcon16Solid';
import { FileFormatPdfIcon20Light } from './FileFormatPdfIcon20Light';
import { FileFormatPdfIcon20Regular } from './FileFormatPdfIcon20Regular';
import { FileFormatPdfIcon20Solid } from './FileFormatPdfIcon20Solid';
import { FileFormatPdfIcon24Regular } from './FileFormatPdfIcon24Regular';
import { FileFormatPdfIcon24Solid } from './FileFormatPdfIcon24Solid';
import { FileFormatPdfIcon32Regular } from './FileFormatPdfIcon32Regular';
import { FileFormatPdfIcon64Regular } from './FileFormatPdfIcon64Regular';
var sizes = {
    16: {
        light: FileFormatPdfIcon16Light,
        regular: FileFormatPdfIcon16Regular,
        solid: FileFormatPdfIcon16Solid,
    },
    20: {
        light: FileFormatPdfIcon20Light,
        regular: FileFormatPdfIcon20Regular,
        solid: FileFormatPdfIcon20Solid,
    },
    24: {
        regular: FileFormatPdfIcon24Regular,
        solid: FileFormatPdfIcon24Solid,
    },
    32: {
        regular: FileFormatPdfIcon32Regular,
    },
    64: {
        regular: FileFormatPdfIcon64Regular,
    },
};
export var FileFormatPdfIcon = forwardRef('FileFormatPdfIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
